import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { Button, TextField, Modal, Checkbox, Box } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { setMeetingSpaces } from "../redux/slices/allMeetingSpacesSlice";
import { MenuItem } from "@mui/material";
import { setCalendar } from "../redux/slices/calendarSlice";
import { setLocation } from "../redux/slices/locationSlice";
import { toast } from "react-toastify";
import Multiselect from "multiselect-react-dropdown";
import "../components/editmodal.css";
import { addOption } from "../redux/slices/capabilitiesSlice";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import EditIcon from "@mui/icons-material/EditNote";
import Divider from "@mui/material/Divider";

import CloseIcon from "@material-ui/icons/Close";
import CalendarMeetingIdField from "./CalendarMeetingIdField";
import { linkedCalendarIds } from "../utils/calendarProvisioning";

const useStyles = makeStyles((theme) => ({
  modalContainer: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",

    width: 450,
    backgroundColor: "#fff",
    boxShadow: "0 0 10px rgba(0, 0, 0, 0.5)",
    paddingTop: 10,
    paddingBottom: 20,
    paddingLeft: 20,
    paddingRight: 20,
    outline: "none",
    borderRadius: 5,
    maxHeight: "90vh",
    overflowY: "auto",
    minHeight: "50vh",
  },
  formContainer: {
    display: "flex",
    flexDirection: "column",
    gap: 20,
  },
  label: {
    fontWeight: "bold",
  },
  fieldContainer: {
    display: "flex",
  },

  buttonContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "1rem",
  },

  buttonSubDiv: {
    display: "flex",
    gap: ".5rem",
  },
  inputContainer: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem",
    width: 350,
    gap: "1rem",
    backgroundColor: "#fff",
    boxShadow: "0 0 10px rgba(0, 0, 0, 0.5)",
    padding: 20,
    outline: "none",
    borderRadius: 6,
  },
  capability: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  firstModal: {
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
  },
  divider: {
    margin: "20px 0",
  },
}));

const EditMeetingSpaceForm = ({
  selectedOption,
  selectedItemId,
  meetingSpaceData,
  handleClose,
  groups,
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const headers = useSelector((state) => state.header);
  const emmsheaders = useSelector((state) => state.emmsheader);
  const oldMeetingSpaceData = useSelector((state) => state.allmeetingspaces);
  const [locationOptions, setLocationOptions] = useState([]);
  const [calendarOptions, setCalendarOptions] = useState([]);
  const capabilitiesOptions = useSelector((state) => state.capabilitiesOptions);
  const options = capabilitiesOptions.options;
  const [userOptions, setUserOptions] = useState([]);
  const [isChecked, setIsChecked] = useState(false);
  const [capacityCheckValue, setCapacityCheckValue] = useState(0);
  const calendarData = useSelector((state) => state.calendar);
  const locationData = useSelector((state) => state.location);
  const [formData, setFormData] = useState({
    name: "",
    capacity: "",
    locationId: "",
    customProperties: {},
    clientId: "",
    meetingspacetype: "",
    calendarMeetingId: "",
    calendarCredentialId: "",
    photoUrl: "",
  });

  /*
    Carries customProperties.calendarEntries, which is what turns the Calendar
    Meeting ID field into a list of room names. Read straight off the calendar
    list in Redux, which is the same list the credential dropdown above renders.
  */
  const selectedCalendarCredential = (calendarData?.calendar || []).find(
    (option) => option.id === formData.calendarCredentialId
  );

  const [showAdvanced, setShowAdvanced] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [newKey, setNewKey] = useState("");
  const [newValue, setNewValue] = useState("");
  const [group, setGroup] = useState("");
  const toggleAdvanced = () => {
    setShowAdvanced((prev) => {
      const newShowAdvanced = !prev;
      if (!newShowAdvanced) {
        setEditMode(false);
      }
      return newShowAdvanced;
    });
  };

  const toggleEditMode = () => {
    setEditMode((prev) => !prev);
  };
  const handleCustomPropertyChange = (event) => {
    const { name, value } = event.target;

    setFormData((prevFormData) => ({
      ...prevFormData,
      customProperties: {
        ...prevFormData.customProperties,
        [name]: value,
      },
    }));
  };
  const handleAddCustomProperty = () => {
    if (newKey && newValue) {
      setFormData((prevFormData) => ({
        ...prevFormData,
        customProperties: {
          ...prevFormData.customProperties,
          [newKey]: newValue,
        },
      }));
      setNewKey("");
      setNewValue("");
    }
  };

  const handleLocationData = () => {
    const requestBody = {
      path: "location",
      query: {},
      emmsId: `${selectedOption}`,
      body: {},
      requestType: "GET",
      headers: emmsheaders?.emmsheaders?.headers,
    };
    const api = localStorage.getItem("api");
    axios
      .post(api + `/emms/piggyback`, requestBody, headers)
      .then((response) => {
        dispatch(setLocation(response.data));
        setLocationOptions(locationData.location);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const handleCalendarData = () => {
    const requestBody = {
      path: "calendar",
      query: {},
      emmsId: `${selectedOption}`,
      body: {},
      requestType: "GET",
      headers: emmsheaders?.emmsheaders?.headers,
    };
    const api = localStorage.getItem("api");
    axios
      .post(api + `/emms/piggyback`, requestBody, headers)
      .then((response) => {
        dispatch(setCalendar(response.data));
        setCalendarOptions(calendarData.calendar);
      })
      .catch((error) => {
        console.error(error);
      });
  };
  const addCustomFeaturesAsOptions = () => {
    let features = [];
    for (let i = 0; i < oldMeetingSpaceData?.allmeetingspaces?.length; i++) {
      const meetingSpace = oldMeetingSpaceData.allmeetingspaces[i];

      if (
        meetingSpace.customProperties &&
        meetingSpace.customProperties.features &&
        Array.isArray(meetingSpace.customProperties.features)
      ) {
        const features = meetingSpace.customProperties.features;
        for (let j = 0; j < features.length; j++) {
          const feature = features[j];

          const { custom } = feature;

          if (custom === true && !options.includes(feature)) {
            dispatch(addOption(feature));
          }
        }
      }
    }
  };
  useEffect(() => {
    handleCalendarData();
    handleLocationData();
    addCustomFeaturesAsOptions();
    const selectedMeetingSpace = meetingSpaceData.find(
      (meetingSpace) => meetingSpace.id === selectedItemId
    );

    if (selectedMeetingSpace) {
      setFormData({
        name: selectedMeetingSpace.name,
        capacity: selectedMeetingSpace.capacity.toString(),
        locationId: selectedMeetingSpace.locationId,
        customProperties: selectedMeetingSpace.customProperties,
        clientId: selectedMeetingSpace.clientId,
        meetingspacetype: selectedMeetingSpace.meetingspacetype,
        calendarMeetingId: selectedMeetingSpace.calendarMeetingId,
        calendarCredentialId: selectedMeetingSpace.calendarCredentialId,
        photoUrl: selectedMeetingSpace.photoUrl,
      });

      const options = selectedMeetingSpace?.customProperties?.features || [];
      setIsChecked(
        selectedMeetingSpace?.customProperties?.strict_cap_check_valid
      );
      setCapacityCheckValue(
        selectedMeetingSpace?.customProperties?.strict_cap_check
      );
      setUserOptions(options);
      setGroup(selectedMeetingSpace?.customProperties?.groups);
    }
  }, [selectedItemId, meetingSpaceData]);

  const handleChange = (event) => {
    const { name, value } = event.target;

    if (name === "shortNavigation") {
      setFormData((prevFormData) => ({
        ...prevFormData,
        customProperties: {
          ...prevFormData.customProperties,
          shortNavigation: value,
        },
      }));
    } else if (name === "GuestWiFiDetails") {
      setFormData((prevFormData) => ({
        ...prevFormData,
        customProperties: {
          ...prevFormData.customProperties,
          GuestWiFiDetails: value,
        },
      }));
    } else if (name === "priority") {
      const floatValue = parseFloat(value);
      if (floatValue !== 1) {
        setIsChecked(false);
        setCapacityCheckValue(0);
        setFormData((prevFormData) => ({
          ...prevFormData,
          customProperties: {
            ...prevFormData.customProperties,
            strict_cap_check: "",
            priority: floatValue,
            strict_cap_check_valid: false,
          },
        }));
      } else {
        setFormData((prevFormData) => ({
          ...prevFormData,
          customProperties: {
            ...prevFormData.customProperties,
            priority: floatValue,
          },
        }));
      }
    } else if (name === "regex") {
      setFormData((prevFormData) => ({
        ...prevFormData,
        customProperties: {
          ...prevFormData.customProperties,
          regex: value,
        },
      }));
    } else if (name === "regex_match_type") {
      setFormData((prevFormData) => ({
        ...prevFormData,
        customProperties: {
          ...prevFormData.customProperties,
          regex_match_type: parseFloat(value),
        },
      }));
    } else if (name === "strict_cap_check_valid") {
      setIsChecked(event.target.checked);
      if (event.target.checked === false) {
        setCapacityCheckValue(0);
      }
      setFormData((prevFormData) => ({
        ...prevFormData,
        customProperties: {
          ...prevFormData.customProperties,
          strict_cap_check_valid: Boolean(event.target.checked),
        },
      }));
    } else if (name === "strict_cap_check") {
      const floatValue = parseFloat(value);
      const isValidNumber = !isNaN(floatValue);
      setCapacityCheckValue(value);
      setFormData((prevFormData) => ({
        ...prevFormData,
        customProperties: {
          ...prevFormData.customProperties,
          strict_cap_check: isValidNumber ? floatValue : 0,
        },
      }));
    } else if (name === "groups") {
      setGroup(value);
      setFormData((prevFormData) => ({
        ...prevFormData,
        customProperties: {
          ...prevFormData.customProperties,
          groups: value,
        },
      }));
    } else {
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: value,
      }));
    }
  };

  const [newCapability, setNewCapability] = useState({
    name: "",
    icon: "",
    custom: true,
  });
  const [showInputFields, setShowInputFields] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewCapability({
      ...newCapability,
      [name]: value,
      custom: true,
    });
  };

  const handleAddCapability = () => {
    dispatch(addOption(newCapability));
    setNewCapability({
      name: "",
      icon: "",
      custom: true,
    });
    setShowInputFields(false);
  };

  useEffect(() => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      customProperties: {
        ...prevFormData.customProperties,
        features: userOptions,
      },
    }));
  }, [userOptions]);

  const handleSubmit = (event) => {
    event.preventDefault();

    const convertedCapacity = parseInt(formData.capacity);
    const json2 = { ...formData };

    if (formData.meetingspacetype == "emms") {
      json2.calendarCredentialId = "";
      json2.calendarMeetingId = "";
    }
    if (!json2.photoUrl) {
      delete json2.photoUrl;
    }
    json2.customProperties = {
      ...json2.customProperties,
      features: userOptions,
    };
    if (!json2.customProperties.priority) {
      json2.customProperties = {
        ...json2.customProperties,
        features: userOptions,
        priority: 0,
      };
    }
    if (json2.customProperties.strict_cap_check_valid === false) {
      delete json2.customProperties.strict_cap_check;
    }
    if (!json2.customProperties.regex) {
      delete json2.customProperties.regex;
      delete json2.customProperties.regex_match_type;
    }

    json2.capacity = convertedCapacity;

    const requestBody = {
      path: "meetingspace",
      query: {},
      emmsId: `${selectedOption}`,
      body: { ...json2, id: selectedItemId },
      requestType: "POST",
      headers: emmsheaders?.emmsheaders?.headers,
    };

    const api = localStorage.getItem("api");
    axios
      .post(api + `/emms/piggyback`, requestBody, headers)
      .then((response) => {
        const editedMeetingSpace = response.data[0];
        const index = oldMeetingSpaceData.allmeetingspaces.findIndex(
          (meetingSpace) => meetingSpace.id === editedMeetingSpace.id
        );

        if (index !== -1) {
          const updatedMeetingSpaceData = [
            ...oldMeetingSpaceData.allmeetingspaces,
          ];
          updatedMeetingSpaceData[index] = editedMeetingSpace;
          dispatch(setMeetingSpaces(updatedMeetingSpaceData));
        } else {
          const updatedMeetingSpaceData = [
            ...oldMeetingSpaceData.allmeetingspaces,
            editedMeetingSpace,
          ];
          dispatch(setMeetingSpaces(updatedMeetingSpaceData));
        }
        toast.success("Updated successfully", {
          position: toast.POSITION.BOTTOM_RIGHT,
        });

        handleClose();
      })
      .catch((error) => {
        toast.error("Couldn't be updated", {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
        console.error("Error updating meeting space:", error);
      });
  };
  const getLabelWithAsterisk = (labelText, isRequired) => {
    return (
      <div style={{ display: "flex", alignItems: "center", width: "110px" }}>
        <label className={classes.label} htmlFor={labelText}>
          {labelText}
        </label>
        {isRequired && <span style={{ color: "red" }}>*</span>}
      </div>
    );
  };

  return (
    <>
      <Modal open={true} onClose={handleClose}>
        <Box className="centered-box">
          <form onSubmit={handleSubmit} className={classes.formContainer}>
            <h4>Edit Meeting Space: {formData.name}</h4>

            {!showAdvanced && (
              <div className={classes.firstModal}>
                <div className={classes.fieldContainer}>
                  {getLabelWithAsterisk("Name:", true)}
                  <TextField
                    required
                    id="name"
                    name="name"
                    style={{ width: 270 }}
                    size="small"
                    variant="outlined"
                    value={formData.name}
                    disabled
                    onChange={handleChange}
                  />
                </div>

                <div className={classes.fieldContainer}>
                  {getLabelWithAsterisk("Capacity:", true)}
                  <TextField
                    required
                    id="capacity"
                    name="capacity"
                    style={{ width: 270 }}
                    variant="outlined"
                    size="small"
                    value={formData.capacity}
                    onChange={handleChange}
                  />
                </div>

                <div className={classes.fieldContainer}>
                  {getLabelWithAsterisk("PhotoURL:", false)}
                  <TextField
                    id="photoUrl"
                    name="photoUrl"
                    size="small"
                    style={{ width: 270 }}
                    variant="outlined"
                    value={formData.photoUrl}
                    onChange={handleChange}
                  />
                </div>

                <div className={classes.fieldContainer}>
                  {getLabelWithAsterisk("Room Priority:", true)}
                  <TextField
                    required
                    id="priority"
                    name="priority"
                    size="small"
                    variant="outlined"
                    style={{ width: 270 }}
                    value={formData?.customProperties?.priority || 0}
                    onChange={handleChange}
                    select
                  >
                    <MenuItem value="1">Board/Special Room</MenuItem>
                    <MenuItem value="0">Normal Room</MenuItem>
                  </TextField>
                </div>

                {formData?.customProperties?.priority == "1" && (
                  <>
                    <div className={classes.fieldContainer}>
                      {getLabelWithAsterisk("Minimum Capacity Check:", true)}
                      <Checkbox
                        checked={isChecked}
                        onChange={handleChange}
                        name="strict_cap_check_valid"
                        color="primary"
                      />
                    </div>

                    {isChecked && (
                      <div className={classes.fieldContainer}>
                        {getLabelWithAsterisk("Capacity Check Value:", false)}
                        <TextField
                          id="strict_cap_check"
                          name="strict_cap_check"
                          label="e.g 15,20"
                          variant="outlined"
                          size="small"
                          style={{ width: 270 }}
                          value={capacityCheckValue}
                          onChange={handleChange}
                        />
                      </div>
                    )}
                  </>
                )}

                <div className={classes.fieldContainer}>
                  {getLabelWithAsterisk("Preferred Host:", false)}
                  <TextField
                    id="regex"
                    name="regex"
                    size="small"
                    variant="outlined"
                    style={{ width: 270 }}
                    value={formData?.customProperties?.regex}
                    onChange={handleChange}
                  />
                </div>
                {formData.customProperties.regex && (
                  <div className={classes.fieldContainer}>
                    {getLabelWithAsterisk("Domain Match Type:", true)}
                    <TextField
                      required
                      id="regex_match_type"
                      name="regex_match_type"
                      size="small"
                      variant="outlined"
                      style={{ width: 270 }}
                      value={formData?.customProperties?.regex_match_type}
                      onChange={handleChange}
                      select
                    >
                      <MenuItem value="1">Strict</MenuItem>
                      <MenuItem value="2">Preferred</MenuItem>
                    </TextField>
                  </div>
                )}

                <div className={classes.fieldContainer}>
                  {getLabelWithAsterisk("Short Navigation:", false)}
                  <TextField
                    id="shortNavigation"
                    name="shortNavigation"
                    size="small"
                    style={{ width: 270 }}
                    variant="outlined"
                    value={formData?.customProperties?.shortNavigation}
                    onChange={handleChange}
                  />
                </div>

                <div className={classes.fieldContainer}>
                  {getLabelWithAsterisk("Capabilities:", false)}
                  <div className={classes.capability}>
                    <Multiselect
                      displayValue="name"
                      id="capabilties"
                      name="capabilties"
                      size="small"
                      label="capabilties"
                      value={formData.customProperties}
                      onRemove={(event) => {
                        const updatedOptions = event;
                        setUserOptions(updatedOptions);
                      }}
                      onSelect={(event) => {
                        const updatedOptions = event;

                        setUserOptions(updatedOptions);
                      }}
                      options={options}
                      selectedValues={userOptions}
                      style={{
                        chips: {
                          background: "#19433E",
                        },
                        option: {
                          background: "#778899",
                        },

                        searchBox: {
                          border: "1px  solid lightgray",
                          position: "relative",
                          width: "34ch",
                          minHeight: "50px",
                        },
                        optionContainer: {
                          maxHeight: "100px",
                          overflowY: "auto",
                          backgroundColor: "#fff",
                        },
                      }}
                    />

                    {showInputFields ? null : (
                      <Button
                        style={{
                          textTransform: "none",
                          width: "auto",
                          padding: "4px",
                        }}
                        variant="contained"
                        size="small"
                        onClick={() => setShowInputFields(true)}
                      >
                        New Capability
                      </Button>
                    )}
                  </div>
                </div>
                {showInputFields && (
                  <div className={classes.inputContainer}>
                    <div className={classes.fieldContainer}>
                      {getLabelWithAsterisk("Name:", true)}
                      <TextField
                        type="text"
                        name="name"
                        size="small"
                        variant="outlined"
                        value={newCapability.name}
                        placeholder="Capability ie. HDMI, USB-C "
                        onChange={handleInputChange}
                      />
                    </div>

                    <div className={classes.fieldContainer}>
                      {getLabelWithAsterisk("Link:", true)}
                      <TextField
                        type="text"
                        name="icon"
                        size="small"
                        variant="outlined"
                        value={newCapability.icon}
                        placeholder="Link to icon"
                        onChange={handleInputChange}
                      />
                    </div>

                    <div className={classes.buttonContainer}>
                      <Button
                        style={{
                          textTransform: "none",
                          padding: "4px",
                        }}
                        variant="outlined"
                        color="error"
                        size="small"
                        onClick={() => setShowInputFields(false)}
                      >
                        Close <CloseIcon fontSize="small" />
                      </Button>
                      <Button
                        style={{
                          textTransform: "none",
                          maxWidth: "10ch",
                        }}
                        type="button"
                        variant="contained"
                        onClick={handleAddCapability}
                      >
                        Add
                      </Button>
                    </div>
                  </div>
                )}

                <div style={{ display: "flex" }}>
                  {getLabelWithAsterisk("Wifi Details:", false)}
                  <TextField
                    id="GuestWiFiDetails"
                    label="Guest WiFi Access Details"
                    name="GuestWiFiDetails"
                    variant="outlined"
                    size="small"
                    value={formData?.customProperties?.GuestWiFiDetails}
                    onChange={handleChange}
                  />
                </div>

                <div className={classes.fieldContainer}>
                  {getLabelWithAsterisk("Meeting Space Type:", true)}
                  <TextField
                    required
                    id="meetingspacetype"
                    name="meetingspacetype"
                    size="small"
                    style={{ width: 270 }}
                    variant="outlined"
                    value={formData.meetingspacetype}
                    onChange={handleChange}
                    select
                  >
                    <MenuItem value="calendar">Calendar</MenuItem>
                    <MenuItem value="emms">EMMS</MenuItem>
                  </TextField>
                </div>

                {formData.meetingspacetype === "calendar" ? (
                  <>
                    <div className={classes.fieldContainer}>
                      {getLabelWithAsterisk("Calendar Credential:", true)}
                      <TextField
                        required
                        id="calendarCredentialId"
                        name="calendarCredentialId"
                        style={{ width: 270 }}
                        size="small"
                        variant="outlined"
                        value={formData.calendarCredentialId}
                        onChange={handleChange}
                        select
                      >
                        {calendarData.calendar?.map((option) => (
                          <MenuItem key={option.id} value={option.id}>
                            {option.credentialName}
                          </MenuItem>
                        ))}
                      </TextField>
                    </div>

                    <div className={classes.fieldContainer}>
                      {getLabelWithAsterisk("Calendar MeetingID:", true)}
                      <CalendarMeetingIdField
                        credential={selectedCalendarCredential}
                        value={formData.calendarMeetingId}
                        takenIds={linkedCalendarIds(
                          meetingSpaceData || oldMeetingSpaceData?.allmeetingspaces,
                          selectedItemId
                        )}
                        onChange={(calendarMeetingId) =>
                          setFormData((prevFormData) => ({
                            ...prevFormData,
                            calendarMeetingId,
                          }))
                        }
                      />
                    </div>
                  </>
                ) : null}

                <div className={classes.fieldContainer}>
                  {getLabelWithAsterisk("Location:", true)}
                  <TextField
                    required
                    id="locationId"
                    name="locationId"
                    label="Location ID"
                    size="small"
                    style={{ width: 270 }}
                    variant="outlined"
                    value={formData.locationId}
                    onChange={handleChange}
                    select
                    disabled
                  >
                    {locationData.location?.map((option) => (
                      <MenuItem key={option.id} value={option.id}>
                        <span style={{ textTransform: "uppercase" }}>
                          {option.floor} FLOOR, {option.building.toUpperCase()},{" "}
                          {option.city.toUpperCase()}
                        </span>
                      </MenuItem>
                    ))}
                  </TextField>
                </div>

                <div className={classes.fieldContainer}>
                  {getLabelWithAsterisk("Group:", true)}
                  <TextField
                    required
                    id="groups"
                    name="groups"
                    variant="outlined"
                    label="eg.Group"
                    size="small"
                    value={group || ""}
                    onChange={handleChange}
                    select
                    style={{}}
                  >
                    {groups?.map((option) => (
                      <MenuItem key={option.id} value={option.id}>
                        <span style={{ textTransform: "uppercase" }}>
                          {option.name}
                        </span>
                      </MenuItem>
                    ))}
                  </TextField>
                </div>
              </div>
            )}
            <div className={classes.buttonContainer}>
              <Button
                style={{
                  textTransform: "none",
                }}
                variant="outlined"
                color="primary"
                onClick={toggleAdvanced}
                startIcon={showAdvanced ? <ArrowBackIcon /> : null}
              >
                {showAdvanced ? "Back" : "Advanced"}
              </Button>
              {showAdvanced && (
                <Button
                  style={{
                    textTransform: "none",
                  }}
                  variant="contained"
                  color="primary"
                  onClick={toggleEditMode}
                  endIcon={!editMode ? <EditIcon /> : null}
                >
                  {editMode ? "Save Changes" : "Edit JSON"}
                </Button>
              )}

              {!showAdvanced && (
                <div className={classes.buttonSubDiv}>
                  <Button
                    style={{ textTransform: "none" }}
                    type="submit"
                    variant="contained"
                    color="primary"
                    size="small"
                  >
                    Update
                  </Button>
                  <Button
                    style={{ textTransform: "none" }}
                    variant="outlined"
                    color="error"
                    onClick={handleClose}
                    size="small"
                  >
                    Cancel
                  </Button>
                </div>
              )}
            </div>
            {showAdvanced && editMode && (
              <div
                style={{
                  maxWidth: "500px",
                  marginTop: "10px",
                  padding: "10px",
                  border: "1px solid #ccc",
                }}
              >
                <h6>Edit Custom Properties</h6>
                <div style={{ marginBottom: "10px" }}>
                  {Object.keys(formData.customProperties).map((key) => {
                    const value = formData.customProperties[key];
                    const isEditable = key !== "features";
                    const displayValue =
                      typeof value === "object" ? JSON.stringify(value) : value;

                    return (
                      <div key={key} style={{ margin: "15px 0" }}>
                        <TextField
                          id={key}
                          name={key}
                          label={key}
                          disabled={!isEditable}
                          variant="outlined"
                          size="small"
                          value={displayValue}
                          onChange={handleCustomPropertyChange}
                        />
                      </div>
                    );
                  })}
                </div>
                {Object.keys(formData.customProperties).length > 0 && (
                  <div className={classes.divider}>
                    <Divider />
                  </div>
                )}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginTop: "10px",
                  }}
                >
                  <TextField
                    id="newKey"
                    name="newKey"
                    label="New Key"
                    variant="outlined"
                    size="small"
                    value={newKey}
                    onChange={(e) => setNewKey(e.target.value)}
                    style={{ marginRight: "10px" }}
                  />
                  <TextField
                    id="newValue"
                    name="newValue"
                    label="New Value"
                    variant="outlined"
                    size="small"
                    value={newValue}
                    onChange={(e) => setNewValue(e.target.value)}
                    style={{ marginRight: "10px" }}
                  />
                  <Button
                    style={{ textTransform: "none" }}
                    variant="contained"
                    color="primary"
                    onClick={handleAddCustomProperty}
                  >
                    Add
                  </Button>
                </div>
              </div>
            )}
            {showAdvanced && (
              <div
                style={{
                  maxWidth: "500px",
                  marginTop: "10px",
                  padding: "10px",
                  border: "1px solid #ccc",
                }}
              >
                <h6>Custom Properties</h6>
                <pre
                  style={{
                    whiteSpace: "pre-wrap",
                    wordWrap: "break-word",
                  }}
                >
                  {JSON.stringify(formData.customProperties, null, 2)}
                </pre>
              </div>
            )}
          </form>
        </Box>
      </Modal>
    </>
  );
};

export default EditMeetingSpaceForm;
